import { createContext } from 'react';
import IThemeContext from './IThemeContext';

const ThemeContext = createContext<IThemeContext | undefined>(undefined);
export default ThemeContext;
